import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceRunDetailQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type InvoiceRunDetailQuery = { __typename?: 'Query', invoiceRun?: { __typename?: 'InvoiceRun', id: string, type: Types.InvoiceRunType, status: Types.InvoiceRunStatus, year: number, iso_month: number, dry_run: boolean, requested_by?: string | null, requested_es_invoice_number?: number | null, resolved_es_invoice_number?: number | null, enqueued_at: string, due_at?: string | null, started_at?: string | null, finished_at?: string | null, last_activity_at?: string | null, processed_count?: number | null, invoice_count?: number | null, total_count?: number | null, error_count?: number | null, open_error_count: number, error?: string | null, parent_run_id?: string | null, collection_draft_regeneration_blocked_reason?: string | null, parent_run?: { __typename?: 'InvoiceRun', id: string, type: Types.InvoiceRunType, status: Types.InvoiceRunStatus, year: number, iso_month: number, dry_run: boolean, processed_count?: number | null, invoice_count?: number | null, error_count?: number | null, open_error_count: number } | null, charge_run?: { __typename?: 'InvoiceRun', id: string, status: Types.InvoiceRunStatus, started_at?: string | null, finished_at?: string | null } | null, errors: Array<{ __typename?: 'InvoiceRunError', id: string, kind: Types.InvoiceRunErrorKind, entity_id: string, entity_name?: string | null, external_vytal_id?: string | null, message: string, first_seen_at: string, last_seen_at: string, resolved_at?: string | null, resolved_by?: string | null, resolution_note?: string | null }>, result_files: Array<{ __typename?: 'InvoiceRunFile', key: string, name: string, size: number, last_modified: string }>, collection_invoices: Array<{ __typename?: 'InvoiceRunCollectionInvoice', invoice_collection_id: string, invoice_collection_name?: string | null, result?: string | null, billomat_url?: string | null, regenerations: Array<{ __typename?: 'InvoiceCollectionDraftRegeneration', id: string, status: Types.InvoiceRunStatus, requested_by?: string | null, enqueued_at: string, started_at?: string | null, finished_at?: string | null, last_activity_at?: string | null, billomat_url?: string | null, updated_in_place?: boolean | null, error?: string | null }> }> } | null };


export const InvoiceRunDetailDocument = gql`
    query InvoiceRunDetail($id: UUID!) {
  invoiceRun(id: $id) {
    id
    type
    status
    year
    iso_month
    dry_run
    requested_by
    requested_es_invoice_number
    resolved_es_invoice_number
    enqueued_at
    due_at
    started_at
    finished_at
    last_activity_at
    processed_count
    invoice_count
    total_count
    error_count
    open_error_count
    error
    parent_run_id
    parent_run {
      id
      type
      status
      year
      iso_month
      dry_run
      processed_count
      invoice_count
      error_count
      open_error_count
    }
    charge_run {
      id
      status
      started_at
      finished_at
    }
    errors {
      id
      kind
      entity_id
      entity_name
      external_vytal_id
      message
      first_seen_at
      last_seen_at
      resolved_at
      resolved_by
      resolution_note
    }
    result_files {
      key
      name
      size
      last_modified
    }
    collection_draft_regeneration_blocked_reason
    collection_invoices {
      invoice_collection_id
      invoice_collection_name
      result
      billomat_url
      regenerations {
        id
        status
        requested_by
        enqueued_at
        started_at
        finished_at
        last_activity_at
        billomat_url
        updated_in_place
        error
      }
    }
  }
}
    `;

/**
 * __useInvoiceRunDetailQuery__
 *
 * To run a query within a React component, call `useInvoiceRunDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRunDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceRunDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceRunDetailQuery(baseOptions: Apollo.QueryHookOptions<InvoiceRunDetailQuery, InvoiceRunDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceRunDetailQuery, InvoiceRunDetailQueryVariables>(InvoiceRunDetailDocument, options);
      }
export function useInvoiceRunDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceRunDetailQuery, InvoiceRunDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceRunDetailQuery, InvoiceRunDetailQueryVariables>(InvoiceRunDetailDocument, options);
        }
export type InvoiceRunDetailQueryHookResult = ReturnType<typeof useInvoiceRunDetailQuery>;
export type InvoiceRunDetailLazyQueryHookResult = ReturnType<typeof useInvoiceRunDetailLazyQuery>;
export type InvoiceRunDetailQueryResult = Apollo.QueryResult<InvoiceRunDetailQuery, InvoiceRunDetailQueryVariables>;